import { render, staticRenderFns } from "./RiskModelCatalogEditor.vue?vue&type=template&id=dfca77c8&scoped=true&"
import script from "./RiskModelCatalogEditor.vue?vue&type=script&lang=js&"
export * from "./RiskModelCatalogEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfca77c8",
  null
  
)

export default component.exports